import { render, staticRenderFns } from "./InfoCollapseArea.vue?vue&type=template&id=de42ed92"
import script from "./InfoCollapseArea.vue?vue&type=script&lang=js"
export * from "./InfoCollapseArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports